import * as React from 'react'
import Box from '@mui/material/Box'

import banner1 from '../../assets/images/banner/banner-login-2023-12-21-1.webp'
import banner2 from '../../assets/images/banner/principal-bi2.png'

// Import Swiper styles
import './styles.css'
import 'swiper/css'
import 'swiper/css/pagination'
import { useMediaQuery, useTheme } from '@mui/material'

// import required modules

function BannerLogin({ bannerEmpresa }) {
  const [banner, setBanner] = React.useState(banner1)
  const [loading, setLoading] = React.useState(true)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  React.useEffect(() => {
    let origin = window.location.origin
    if (origin === 'https://bi.mobioh.com.br') {
      setBanner(banner2)
      setLoading(false)
    } else {
      setBanner(banner1)
      setLoading(false)
    }
  }, [])

  return (
    <Box
      sx={{
        height: '100vh',
        backgroundColor: '#fFF',
      }}
    >
      {!loading && (
        <img
          src={bannerEmpresa || banner}
          style={{ height: isMobile ? 'auto' : '100vh', width: '100%' }}
        />
      )}
    </Box>
  )
}

export default BannerLogin
